import deepmerge from "@suid/utils/deepmerge";
export function mergeSxObjects(object, ...sources) {
    return sources.reduce((target, source, index) => deepmerge(target, source, {
        clone: !!index,
        sortKeys: true,
    }), object);
}
export default mergeSxObjects;
